import { createFileRoute, redirect } from '@tanstack/react-router';

/** Заход на /owner/site открывает дефолтный подраздел (контент). */
export const Route = createFileRoute('/_authed/owner/site/')({
  beforeLoad: () => {
    throw redirect({ to: '/owner/site/content' });
  },
});
